import { getInstance } from '@/auth'
import fetch from '@/fetch'
import { Methods } from './utils/Factory'

export default {
  getBase() {
    return Methods.get()({}, { query: 'Base' })
  },
  subscription({ item, state }) {
    return fetch(`/api/subscription/${state ? 'enable' : 'disable'}/${item}`)
  },
  getPrice(item, options = {}) {
    if (item instanceof Array) {
      return fetch(`/api/pricing`, {
        method: 'POST',
        body: JSON.stringify(item.map(i => ({ item: i, ...options }))),
      }).then(res => res.json())
    } else {
      return fetch(`/api/pricing/${item}?` + new URLSearchParams(options).toString()).then(res => res.json())
    }
  },
}
